import React, {Component} from "react";
import axios from "axios";
import axiosConfig from "../../../utils/axiosConfig";
import messageCodes from "../../../utils/messageCodes";
import {showToastForBackend, showToastForFrontend} from "../../../actions/toastActions";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";

class ExportPanel extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            exporting: false,
            base64ExportContent: "",
            filename: "exportedLogic.txt",
            selected: false
        };

        this.getExportLogics = this.getExportLogics.bind(this);
        this.onNameValueChange = this.onNameValueChange.bind(this);
        this.onDownload = this.onDownload.bind(this);
        this.onSelected = this.onSelected.bind(this);
        this.onExportLogic = this.onExportLogic.bind(this);
    }


    onSelected() {
        this.setState({
            selected: !this.state.selected
        });
    }

    onExportLogic() {
        this.getExportLogics();
    }

    getExportLogics() {
        let requestBody = {
            logicIds: this.props.logicIds,
            selected: this.state.selected
        };

        this.setState(() => ({exporting: true}), function () {
            axios.post(this.props.properties.logicUrl + "/export", requestBody, axiosConfig())
                .then((response) => {
                    if (response.data) {
                        this.setState(() => ({
                            base64ExportContent: response.data,
                            exporting: false
                        }));
                    }
                })
                .catch(err => {
                    if (err.response) {
                        this.props.showToastForBackend(err.response.data);
                    } else {
                        this.props.showToastForFrontend(messageCodes.CONNECTION_ERROR);
                    }
                    this.setState({
                        exporting: false
                    });
                });
        });
    }


    handleGroundClick(e) {
        if (e.target.className === "export-logic-wrapper") {
            this.props.toggleExportPanel();
        }
    }

    onNameValueChange(e) {
        this.setState({
            filename: e.target.value
        });
    }

    onDownload() {
        const base64ExportContent = this.state.base64ExportContent;
        const element = document.createElement("a");
        const file = new Blob([base64ExportContent], {type: 'text/plain'});
        element.href = URL.createObjectURL(file);
        element.download = this.state.filename;
        document.body.appendChild(element);
        element.click();
    }


    render() {
        return (
            <div className="export-logic-wrapper" onClick={(e) => this.handleGroundClick(e)}>
                <div className="export-logic">
                    <div className="header">
                        <h2 className="title">Export logic</h2>
                        <button className="action-button" onClick={this.onExportLogic}>
                            <span className="button-label">Export</span>
                            <i
                                className={"material-icons " + (this.state.exporting ? "animate" : "")}
                            >download</i>
                        </button>
                    </div>
                    <div className="content">
                        <div className="export-checkbox-wrapper">
                            <label className="checkbox-label">
                                <input type="checkbox" className="checkbox"
                                       checked={this.state.selected}
                                       onChange={this.onSelected}/>
                                enable cascading export</label>
                        </div>
                        <FormattedMessage id="Output Base64 string">
                            {placeholder =>
                                <textarea name="exportContent"
                                          className="export-textarea"
                                          placeholder={placeholder}
                                          value={this.state.base64ExportContent}/>
                            }
                        </FormattedMessage>
                        {(this.state.base64ExportContent) &&
                            <div className="filename-wrapper">
                                <label className="filename-label">
                                    Save to file:
                                </label>
                                <input
                                    value={this.state.filename}
                                    type="text"
                                    name="filename"
                                    className="name-input"
                                    onChange={this.onNameValueChange}
                                />
                                <button className="action-button" onClick={this.onDownload}>
                                    <span className="button-label">Save</span>
                                    <i
                                        className={"material-icons " + (this.state.exporting ? "animate" : "")}
                                    >save</i>
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}


function mapStateToProps(state) {
    return {
        properties: state.properties,
        contextProperties: state.contextProperties
    }
}

export default connect(mapStateToProps, {showToastForBackend, showToastForFrontend})(ExportPanel);